/*
 * Behavior related to videos.
 */
var PdfController = (function ($) {
  
  function ready() {
    $("a.pdf").each(function () {
      var a = $(this);
      a.append("<span class='pdf-download' />");
    });
  }
  
  $(ready);
  
})(jQuery);